
import { RevLink } from '@ds/components/Link'

import translations from '../../pages/product.translations'

export default {
  components: {
    RevLink,
  },
  computed: {
    translations: () => translations,
  },
}
